<template>
  <div>
    <b-tabs class="col-12 px-0 mx-0 mt-2 my-0 py-0" content-class="mt-3">
      <!--b-tab class="px-0 col-12 border-0">
        <template v-slot:title>
          <div class="col-12 text-center">
            <fa-icon
              class="mr-2"
              name="money-bill"
            />Pricing
          </div>
        </template>
        <b-card no-body class="border-0 mx-0 px-0 pl-0 pr-0 col-12">
          <b-row>
            <b-form-group 
              label-cols="4"
              label="VAT rate (%)"
              class="col-12"
            >
              <b-form-input  
                id="gdq_vat" 
                class="form-control col-7"
                v-model="gdq_vat"
                v-on:change="savepref('gdq_vat',gdq_vat)" 
                autocomplete="off"
              >
              </b-form-input>
            </b-form-group>
          </b-row>
          <b-row>
            <b-form-group 
              label-cols="4"
              label="GDQ Report price per survey"
              class="col-12"
            >
              <b-form-input  
                id="gdqreport_price" 
                class="form-control col-7"
                v-model="gdqreport_price"
                v-on:change="savepref('gdqreport_price',gdqreport_price)" 
                autocomplete="off"
              >
              </b-form-input>
            </b-form-group>
          </b-row>
        </b-card>
      </b-tab -->
      <!-- b-tab lazy class="px-0 col-12 border-0">
        <template v-slot:title>
          <div class="text-center">
            <fa-icon
              class="mr-2"            
              name="envelope"
            />Invitations
          </div>
        </template>
        <b-card class="border-0 mx-auto px-0 col-12">
          <DefaultMailTexts />
        </b-card>
      </b-tab -->
      <b-tab lazy>
         <template v-slot:title>
          <div class="col-12 text-center">
            <fa-icon
              class="mr-2"
              name="envelope-open-text"
            />
            Mail Settings
          </div>
        </template>
        <b-card no-body class="border-0 mx-0 px-0 pl-0 pr-0 col-12">
          <MailSettings />
        </b-card>
      </b-tab>       
      <!--b-tab lazy>
        <template v-slot:title>
          <div class="col-12 text-center">
            <fa-icon
              class="mr-2"
              name="envelope-open-text"
            />
            New user
          </div>
        </template>
        <b-card no-body class="border-0 mx-0 px-0 pl-0 pr-0 col-12">
          <DefaultMailNewUser />
        </b-card>
      </b-tab>
      <b-tab lazy>
        <template v-slot:title>
          <div class="col-12 text-center">
            <fa-icon
              class="mr-2"
              name="envelope-open-text"
            />
            Invoice
          </div>
        </template>
        <b-card no-body class="border-0 mx-0 px-0 pl-0 pr-0 col-12">
          <DefaultMailNewInvoice />
        </b-card>
      </b-tab -->
      <b-tab lazy class="px-0 col-12 border-0">
        <template v-slot:title>
          <div class="text-center">
            <fa-icon
              class="mr-2"
              name="edit"
            />System Texts
          </div>
        </template>
        <b-card class="border-0 mx-auto px-0 col-12">
          <SystemTexts />
        </b-card>
      </b-tab>
      <b-tab lazy class="px-0 col-12 border-0">
        <template v-slot:title>
          <div class="text-center">
            <fa-icon
              class="mr-2"
              name="globe-americas"
            />Countries
          </div>
        </template>        
        <Maintenance tablename="g_countries"/>     
      </b-tab>
      <b-tab lazy class="px-0 col-12 border-0">
        <template v-slot:title>
          <div class="text-center">
            <fa-icon
              class="mr-2"
              name="language"
            />Languages
          </div>
        </template>
        <Maintenance tablename="g_languages"/>     
      </b-tab>
      <b-tab lazy class="px-0 col-12 border-0">
        <template v-slot:title>
          <div class="text-center">
            <fa-icon
              class="mr-2"
              name="search"
            />Messages
          </div>
        </template>
        <b-card class="border-0 mx-auto px-0 col-12">
          <Maintenance tablename="g_systemmessages" />
        </b-card>
      </b-tab>
      <b-tab lazy class="px-0 col-12 border-0">
        <template v-slot:title>
          <div class="text-center">
            <fa-icon
              class="mr-2"
              name="cog"
            />GDQ
          </div>
        </template>
        <b-card class="border-0 mx-auto px-0 col-12">
          <GDQSettings />
        </b-card>
      </b-tab>
      <b-tab lazy class="px-0 col-12 border-0">
        <template v-slot:title>
          <div class="text-center">
            <fa-icon
              class="mr-2"
              name="cog"
            />GDQ Short
          </div>
        </template>
        <b-card class="border-0 mx-auto px-0 col-12">
          <GDQShortSettings />
        </b-card>
      </b-tab>
      <b-tab lazy class="px-0 col-12 border-0">
        <template v-slot:title>
          <div class="text-center">
            <fa-icon
              class="mr-2"
              name="cog"
            />OSC
          </div>
        </template>
        <b-card class="border-0 mx-auto px-0 col-12">
          <OSCSettings />
        </b-card>
      </b-tab>
      <b-tab lazy class="px-0 col-12 border-0">
        <template v-slot:title>
          <div class="text-center">
            <fa-icon
              class="mr-2"
              name="cog"
            />Aggr. reports
          </div>
        </template>
        <b-card class="border-0 mx-auto px-0 col-12">
          <AggregatedReportSettings />
        </b-card>
      </b-tab>
      <b-tab lazy class="px-0 col-12 border-0">
        <template v-slot:title>
          <div class="text-center">
            <fa-icon
              class="mr-2"
              name="cog"
            />Checklist
          </div>
        </template>
        <b-card class="border-0 mx-auto px-0 col-12">
          <ChecklistSettings />
        </b-card>
      </b-tab>
      <b-tab lazy class="px-0 col-12 border-0">
        <template v-slot:title>
          <div class="text-center">
            <fa-icon
              class="mr-2"
              name="user-lock"
            />API Users
          </div>
        </template>
        <b-card class="border-0 mx-auto px-0 col-12">
          <Maintenance tablename="g_apiusers" />
        </b-card>
      </b-tab>           
    </b-tabs>
  </div>
</template>
<script>
import SystemTexts from './SystemTexts';
//import DefaultMailNewUser from './DefaultMailNewUser';
//import DefaultMailNewInvoice from './DefaultMailNewInvoice';
//import DefaultMailTexts from './DefaultMailTexts';
import GDQSettings from './GDQSettings';
import GDQShortSettings from './GDQShortSettings';
import OSCSettings from './OSCSettings';
import AggregatedReportSettings from './AggregatedReportSettings';
import ChecklistSettings from './ChecklistSettings.vue';
import MailSettings from './MailSettings.vue';
import Maintenance from './Maintenance';
export default {
  name: 'SystemSettings',
  mounted() {
    this.prefs_get();
  },
  components: {
    SystemTexts,
    // DefaultMailNewUser,
    // DefaultMailNewInvoice,
    Maintenance,
    GDQSettings,
    GDQShortSettings,
    OSCSettings,
    AggregatedReportSettings,
    ChecklistSettings,
    MailSettings,
  },
  data: function() {
    return {
      gdqreport_price: 0,
      gdq_vat: 0,
    }
  },
  methods: {
    savepref(key,value) {
      if (key.indexOf('_date') != -1) {
        value = this.format_date(value);
      }
      this.$store.dispatch('syspref_save', { key: key,value: value });
    },
    prefs_get() {
      this.$store.dispatch('syspref_fetch', { key: 'gdqreport_price' })
      .then((resp) => {
        this.gdqreport_price = resp.data.value;
        this.$store.dispatch('syspref_fetch', { key: 'gdq_vat' })
        .then((resp) => {
          this.gdq_vat = resp.data.value;
        });
      });
    },
  },
}
</script>
<style>
</style>
